export default __webpack_public_path__ + "static/hiit_it_interval_timer_iphone-reset@4x-4af1b7fc405eb164e04c6b2273dc5b64.webp";